import { theme } from "../../Theme";
import { ButtonType } from "./CustomButton.types";
import { alpha } from "@mui/material";
export const buttonStyle = {
    marginBlock: 1,
    marginInline: 1,
    border: 1,
    borderRadius: "5px",
    color: theme.palette.primary.main,
    borderColor: theme.palette.info.light,
    boxShadow: "none",
    height: "35.5px",
    width: "150px",
    padding: "2px",
};
const baseLargeButtonStyle = {
    paddingTop: "22px",
    paddingBottom: "22px",
    borderRadius: "12px",
    border: 0,
    with: "161px",
    height: "48px",
};
const baseSmallButtonStyle = {
    borderRadius: "12px",
    border: 0,
    with: "149px",
    height: "36px",
};
const getLargeStyle = (bgColor, textColor) => ({
    button: Object.assign({ background: bgColor }, baseLargeButtonStyle),
    text: Object.assign(Object.assign({}, theme.typography.labelLarge), { color: textColor }),
});
const getSmallStyle = (bgColor, textColor) => ({
    button: Object.assign({ background: bgColor }, baseSmallButtonStyle),
    text: Object.assign(Object.assign({}, theme.typography.labelSmall), { color: textColor }),
});
export const ButtonStyleEnum = {
    [ButtonType.save]: {
        button: {
            background: "#19BD63",
            borderColor: theme.palette.primary.contrastText,
        },
        text: Object.assign(Object.assign({}, theme.typography.labelLarge), { color: theme.palette.primary.contrastText }),
    },
    [ButtonType.default]: {
        button: {
            background: theme.palette.primary.contrastText,
            borderColor: theme.palette.info.light,
        },
        text: Object.assign(Object.assign({}, theme.typography.labelLarge), { color: theme.palette.info.main }),
    },
    [ButtonType.delete]: {
        button: {
            background: theme.palette.primary.contrastText,
            borderColor: "#FD0D0D82",
        },
        text: Object.assign(Object.assign({}, theme.typography.labelLarge), { color: "#F60505" }),
    },
    [ButtonType.upload]: {
        button: {
            background: theme.palette.primary.contrastText,
            borderColor: theme.palette.info.light,
        },
        text: Object.assign(Object.assign({}, theme.typography.labelLarge), { color: theme.palette.info.main }),
    },
    [ButtonType.iconDataGrid]: {
        button: {
            background: theme.palette.primary.contrastText,
            border: 0,
            backgroundColor: "transparent",
            minWidth: "35px",
            padding: "2px",
            margin: "2px",
            width: "auto",
        },
        text: Object.assign(Object.assign({}, theme.typography.labelLarge), { color: theme.palette.info.main }),
    },
    [ButtonType.iconButton]: {
        button: Object.assign(Object.assign({}, buttonStyle), { color: "#19BD63", borderColor: "#19BD63", background: "#FFFFFF", minWidth: "35px", marginLeft: 0, marginRight: 0, marginTop: "16px", marginBottom: "16px" }),
        text: {
            color: "#19BD63",
            fontSize: "14px",
        },
    },
    [ButtonType.actionButton]: {
        button: {
            background: theme.palette.info.main,
            marginBottom: "16px",
            marginLeft: "auto",
            marginRight: "auto",
            border: 0,
            borderRadius: "10px",
            boxShadow: "none",
            height: "50px",
            width: "100%",
        },
        disable: {
            background: "#bbbbbb !important",
        },
        loading: {
            background: "#119EDB !important",
        },
        text: {
            color: "#ffffff",
        },
    },
    [ButtonType.linkButton]: {
        button: {
            maxWidth: "400px",
        },
        text: {},
    },
    [ButtonType.outlinedButton]: {
        button: {
            border: "2px solid",
            borderRadius: "8px",
        },
        text: Object.assign(Object.assign({}, theme.typography.labelLarge), { color: theme.palette.info.main }),
    },
    [ButtonType.textButton]: {
        button: {},
        text: {},
    },
    [ButtonType.largePrimaryDark]: getLargeStyle(theme.palette.primary.main, "#fff"),
    [ButtonType.largePrimaryMain]: getLargeStyle(theme.customColors.primary[60], "#fff"),
    [ButtonType.largePrimaryLight]: getLargeStyle(alpha(theme.palette.primary.main, 0.4), "#fff"),
    [ButtonType.largeSecondaryDark]: getLargeStyle(theme.customColors.neutral[70], "#000"),
    [ButtonType.largeSecondaryMain]: getLargeStyle(theme.customColors.neutral.surfaceContainer, "#000"),
    [ButtonType.largeSecondaryLight]: getLargeStyle(alpha(theme.customColors.neutral.surfaceContainer, 0.4), "#000"),
    [ButtonType.largeErrorDark]: getLargeStyle(theme.customColors.error[50], "#fff"),
    [ButtonType.largeErrorMain]: getLargeStyle(theme.customColors.error[90], "#fff"),
    [ButtonType.largeErrorLight]: getLargeStyle(theme.customColors.error[95], "#fff"),
    [ButtonType.smallPrimaryDark]: getSmallStyle(theme.palette.primary.main, "#fff"),
    [ButtonType.smallPrimaryMain]: getSmallStyle(theme.customColors.primary[60], "#fff"),
    [ButtonType.smallPrimaryLight]: getSmallStyle(alpha(theme.palette.primary.main, 0.4), "#fff"),
    [ButtonType.smallSecondaryDark]: getSmallStyle(theme.customColors.neutral[70], "#000"),
    [ButtonType.smallSecondaryMain]: getSmallStyle(theme.customColors.neutral.surfaceContainer, "#000"),
    [ButtonType.smallSecondaryLight]: getSmallStyle(alpha(theme.customColors.neutral.surfaceContainer, 0.4), "#000"),
    [ButtonType.smallErrorDark]: getSmallStyle(theme.customColors.error[50], "#fff"),
    [ButtonType.smallErrorMain]: getSmallStyle(theme.customColors.error[90], "#fff"),
    [ButtonType.smallErrorLight]: getSmallStyle(theme.customColors.error[95], "#fff"),
};
